import {Action} from '@ngrx/store';
import * as apiBenutzerverwaltung from '../../../clients/benutzerverwaltung';
import * as apiVorlagen from '../../../clients/vorlagen';
import {AufgabePandemieLevel} from './checklisten.models';
import {AKTUELLE_VORLAGE_TYPEN_SETZEN} from '../funktionsbereiche-rollen/funktionsbereiche-rollen.actions.ui';

export const PAGE_STATE_RESET = '[ChecklistenPage] Page State reset';

export const AKTUELLEN_FUNKTIONSBEREICH_GESETZT = '[ChecklistenPage] Aktuellen Funktionsbereich gesetzt';
export const AKTUELLE_CHECKLISTE_SETZEN = '[ChecklistenPage] Aktuelle Checkliste setzen';
export const AKTUELLE_AUFGABE_GESETZT = '[ChecklistenPage] Aktuelle Aufgabe gesetzt';
export const NEUE_CHECKLISTE = '[ChecklistenPage] Aktuelle Checkliste gesetzt';

export const AKTUELLE_CHECKLISTE_TYPEN_SETZEN = '[ChecklistenPage] Aktuelle Checkliste Typen setzen';

export const FREIGABE_ROLLEN_SETZEN = '[ChecklistenPage] Freigabe-Rollen setzen';
export const FREIGABE_ROLLEN_LOESCHEN = '[ChecklistenPage] Freigabe-Rolle löschen';

export const LESE_ROLLEN_SETZEN = '[ChecklistenPage] Lese-Rollen setzen';
export const LESE_ROLLEN_LOESCHEN = '[ChecklistenPage] Lese-Rolle löschen';

export const ABARBEITEN_ROLLEN_SETZEN = '[ChecklistenPage] Abarbeiten-Rollen setzen';
export const ABARBEITEN_ROLLEN_LOESCHEN = '[ChecklistenPage] Abarbeiten-Rolle löschen';

export const PANDEMIE_LEVEL_SETZEN = '[ChecklistenPage] Pandemie-Level setzen';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// FUNKTIONSBEREICHE-CHECKLISTE(N)
export class AktuellenFunktionsbereichSetzenAction implements Action {
    readonly type = AKTUELLEN_FUNKTIONSBEREICH_GESETZT;

    constructor(public payload: apiBenutzerverwaltung.Funktionsbereich) {
    }
}

export class AktuelleChecklisteSetzenAction implements Action {
    readonly type = AKTUELLE_CHECKLISTE_SETZEN;

    constructor(public payload: apiVorlagen.Checkliste) {
    }
}

export class AktuelleAufgabeSetzenAction implements Action {
    readonly type = AKTUELLE_AUFGABE_GESETZT;

    constructor(public payload: apiVorlagen.Aufgabe) {
    }
}


export class FreigabeRollenSetzenAction implements Action {
    readonly type = FREIGABE_ROLLEN_SETZEN;

    constructor(public payload: Array<string>) {
    }
}

export class AbarbeitenRollenSetzenAction implements Action {
    readonly type = ABARBEITEN_ROLLEN_SETZEN;

    constructor(public payload: Array<string>) {
    }
}


export class LeseRollenSetzenAction implements Action {
    readonly type = LESE_ROLLEN_SETZEN;

    constructor(public payload: Array<string>) {
    }
}

export class NeueChecklisteAction implements Action {
    readonly type = NEUE_CHECKLISTE;

    constructor(public payload: apiVorlagen.Checkliste, public funktionsbereich: apiVorlagen.Funktionsbereich) {
    }
}

export class AktuelleChecklisteTypenSetzenAction implements Action {
    readonly type = AKTUELLE_CHECKLISTE_TYPEN_SETZEN;
    constructor(public payload: Array<string>) {
    }
}

export class LeseRollenLoeschenAction implements Action {
    readonly type = LESE_ROLLEN_LOESCHEN;

    constructor() {
    }
}

export class FreigabeRollenLoeschenAction implements Action {
    readonly type = FREIGABE_ROLLEN_LOESCHEN;

    constructor() {
    }
}

export class AbarbeitenRollenLoeschenAction implements Action {
    readonly type = ABARBEITEN_ROLLEN_LOESCHEN;

    constructor() {
    }
}

export class PandemieLevelSetzenAction implements Action {
    readonly type = PANDEMIE_LEVEL_SETZEN;

    constructor(public payload: AufgabePandemieLevel, public wert: boolean) {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    AktuellenFunktionsbereichSetzenAction
    | AktuelleChecklisteSetzenAction
    | NeueChecklisteAction
    | AktuelleChecklisteTypenSetzenAction
    | AktuelleAufgabeSetzenAction
    | LeseRollenSetzenAction
    | AbarbeitenRollenSetzenAction
    | FreigabeRollenSetzenAction
    | LeseRollenLoeschenAction
    | FreigabeRollenLoeschenAction
    | AbarbeitenRollenLoeschenAction
    | PandemieLevelSetzenAction
    | PageStateResetAction
    ;
